import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Grid, Link, Paper, Typography } from '@mui/material';
import history from 'src/history';
import assetActivityMap from 'src/web-ui/images/asset_activity_map.png';
import chartPng from 'src/web-ui/images/chart.png';
import compareChartPng from 'src/web-ui/images/compare_chart.png';
import tablePng from 'src/web-ui/images/table.png';
import { makeStyles } from 'tss-react/mui';
import { PageContainer } from './components/PageContainer';

const useStyles = makeStyles()((theme) => ({
  image: {
    width: '100%',
    height: '260px',
    marginTop: theme.spacing(1),
  },
}));

export default function About() {
  const { classes } = useStyles();

  const handleViewDashboard = () => {
    history.push(`dashboards/map`);
  };

  return (
    <PageContainer>
      <Box minHeight="100%">
        <Grid container spacing={4}>
          <Grid size={{ md: 9, sm: 12 }}>
            <Box mt={12}>
              <Typography variant="h2" fontWeight={600}>
                Your eyes on Western Canada’s oil and gas market
              </Typography>
            </Box>

            <Typography variant="subtitle1" maxWidth={600} mt={4}>
              Market & Asset Intelligence aggregates all oil and gas industry
              news and market data to notify you of exactly who’s buying,
              selling, and drilling around you.
            </Typography>

            <Box sx={{ mt: 2 }}>
              <Link
                href={
                  'https://www.stackdx.com/solutions/market-asset-intelligence/'
                }
                target="_blank"
              >
                Learn More
              </Link>
            </Box>

            <Box mt={4}>
              <Typography variant="h4" fontWeight={600} gutterBottom>
                Get started now
              </Typography>
              <Button
                variant="contained"
                onClick={handleViewDashboard}
                endIcon={<ArrowForwardIcon />}
                color={'secondary'}
              >
                See dashboards
              </Button>
            </Box>
          </Grid>
        </Grid>

        <Box mt={12} mb={4}>
          <Typography variant="h4" fontWeight={600}>
            Features
          </Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid size={{ md: 6, sm: 12 }}>
            <Paper>
              <Box p={2}>
                <Typography variant="h6">View data back to 2018</Typography>
                <img alt="logo" src={tablePng} className={classes.image} />
              </Box>
            </Paper>
          </Grid>
          <Grid size={{ md: 6, sm: 12 }}>
            <Paper>
              <Box p={2}>
                <Typography variant="h6">Industry specific charts</Typography>
                <img alt="logo" src={chartPng} className={classes.image} />
              </Box>
            </Paper>
          </Grid>
          <Grid size={{ md: 6, sm: 12 }}>
            <Paper>
              <Box p={2}>
                <Typography variant="h6">Compare companies</Typography>
                <img
                  alt="logo"
                  src={compareChartPng}
                  className={classes.image}
                />
              </Box>
            </Paper>
          </Grid>
          <Grid size={{ md: 6, sm: 12 }}>
            <Paper>
              <Box p={2}>
                <Typography variant="h6">Asset transfer maps</Typography>
                <img
                  alt="logo"
                  src={assetActivityMap}
                  className={classes.image}
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>
        <Box mt={4} mb={8}>
          <Typography textAlign="center" variant="h5">
            and more...
          </Typography>
        </Box>
      </Box>
    </PageContainer>
  );
}
